import { render, staticRenderFns } from "./CalculatorMainSection.vue?vue&type=template&id=35884fb4&scoped=true"
import script from "./CalculatorMainSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorMainSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalculatorMainSection.vue?vue&type=style&index=0&id=35884fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35884fb4",
  null
  
)

export default component.exports